// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/Images/Start/StartButtonImg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/Images/Start/StartButtonImg-Hover.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testing {
  position: absolute;

  left: 200px;
  top: 200px;

  width: 400px;
  Height: 100px;
}

#startContainer {
  display: flex;

  aspect-ratio: 16/9;
  max-width: 100%;
  max-height: 100%;

  align-items: center;
  justify-content: center;
}

#startRatio {
  display: flex;
  flex-grow: 1;
  
  
  max-width: 177.778vh;

  aspect-ratio: 16/9;

  
  align-items: flex-end;
  justify-content: center;

  /* background-color: orange;
  opacity: 0.7; */
}

#startDiv {
  position: relative;
  bottom: -0.4px;

  width: 28.95833%;
  height: 6.7592%;

  clip-path: polygon(13.1% 0%, 86.9% 0%, 100% 100%, 0% 100%);
}

#startButton {
  /* Content */
  opacity: 0;

  /* Size & Position*/
  position: absolute;

  z-index: 1;

  left: 50%;
  bottom: -100%;

  transform: translate(-50%);

  height: 100%;
  width: 100%;

  border-width: 0;

  background-size: cover;

  transition: opacity 0.2s ease-in-out;

  animation-name: start-rise;
  animation-duration: 0.4s;
  animation-delay: 1.5s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
}

#startButton:focus~#startButtonImage {  
  opacity: 0;
  transition: opacity 0.2s ease-in-out; 
} 

#startButton:hover~#startButtonImage {
  opacity: 0;
}

#startButton:focus~#startButtonHighlight {
  opacity: 1;
}

#startButton:hover~#startButtonHighlight {
  opacity: 1;
}


#startButtonImage {
    /* Content */
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
  
    /* Size & Position*/
    position: absolute;
    left: 50%;
    bottom: -100%;
    transform: translate(-50%);
  
    height: 100%;
    width: 100%;

    pointer-events: none;
  
    animation-name: start-rise;
    animation-timing-function: ease-in-out;
    animation-duration: 0.4s;
    animation-delay: 1.5s;
    animation-fill-mode: forwards;
} 

#startButtonHighlight {
  /* Content */
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  opacity: 0;
  transition: opacity 0.2s ease-in-out;

  /* Size & Position*/
  position: absolute;
  left: 50%;
  bottom: -100%;
  transform: translate(-50%);

  height: 100%;
  width: 100%;

  pointer-events: none;

  animation-name: start-rise;
  animation-timing-function: ease-in-out;
  animation-duration: 0.4s;
  animation-delay: 1.5s;
  animation-fill-mode: forwards;
} 

/* This is here to ensure the video never bleeds through the button image x.x */
#startButtonBackground {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 1;

  /* Size & Position*/
  position: absolute;
  left: 50%;
  bottom: -100%;
  transform: translate(-50%);

  height: 100%;
  width: 100%;

  pointer-events: none;

  animation-name: start-rise;
  animation-timing-function: ease-in-out;
  animation-duration: 0.4s;
  animation-delay: 1.5s;
  animation-fill-mode: forwards;
}

#EnvSelect {
  position: absolute;
  width: 430px;
  height: 1em;

  top: 10px;
  left: 10px;

  font-size: 2em;

  z-index: inherit;

  color: Black;

  background-color: Green;
}

@keyframes start-rise {
  0% {
    bottom: -100%;
    pointer-events: none;
  }

  99% {
    pointer-events: none;
  }

  100% {
    bottom: 0px;
    pointer-events: all;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Start.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;;EAElB,WAAW;EACX,UAAU;;EAEV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;;EAEb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;;EAEhB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;;;EAGZ,oBAAoB;;EAEpB,kBAAkB;;;EAGlB,qBAAqB;EACrB,uBAAuB;;EAEvB;iBACe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;;EAEd,gBAAgB;EAChB,eAAe;;EAEf,0DAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,UAAU;;EAEV,mBAAmB;EACnB,kBAAkB;;EAElB,UAAU;;EAEV,SAAS;EACT,aAAa;;EAEb,0BAA0B;;EAE1B,YAAY;EACZ,WAAW;;EAEX,eAAe;;EAEf,sBAAsB;;EAEtB,oCAAoC;;EAEpC,0BAA0B;EAC1B,wBAAwB;EACxB,qBAAqB;EACrB,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;AAGA;IACI,YAAY;IACZ,gDAA4D;IAC5D,UAAU;IACV,oCAAoC;;IAEpC,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,0BAA0B;;IAE1B,YAAY;IACZ,WAAW;;IAEX,oBAAoB;;IAEpB,0BAA0B;IAC1B,sCAAsC;IACtC,wBAAwB;IACxB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;EACE,YAAY;EACZ,gDAAkE;EAClE,UAAU;EACV,oCAAoC;;EAEpC,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,0BAA0B;;EAE1B,YAAY;EACZ,WAAW;;EAEX,oBAAoB;;EAEpB,0BAA0B;EAC1B,sCAAsC;EACtC,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,+EAA+E;AAC/E;EACE,gDAA4D;EAC5D,UAAU;;EAEV,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,0BAA0B;;EAE1B,YAAY;EACZ,WAAW;;EAEX,oBAAoB;;EAEpB,0BAA0B;EAC1B,sCAAsC;EACtC,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;;EAEX,SAAS;EACT,UAAU;;EAEV,cAAc;;EAEd,gBAAgB;;EAEhB,YAAY;;EAEZ,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF","sourcesContent":[".testing {\r\n  position: absolute;\r\n\r\n  left: 200px;\r\n  top: 200px;\r\n\r\n  width: 400px;\r\n  Height: 100px;\r\n}\r\n\r\n#startContainer {\r\n  display: flex;\r\n\r\n  aspect-ratio: 16/9;\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n#startRatio {\r\n  display: flex;\r\n  flex-grow: 1;\r\n  \r\n  \r\n  max-width: 177.778vh;\r\n\r\n  aspect-ratio: 16/9;\r\n\r\n  \r\n  align-items: flex-end;\r\n  justify-content: center;\r\n\r\n  /* background-color: orange;\r\n  opacity: 0.7; */\r\n}\r\n\r\n#startDiv {\r\n  position: relative;\r\n  bottom: -0.4px;\r\n\r\n  width: 28.95833%;\r\n  height: 6.7592%;\r\n\r\n  clip-path: polygon(13.1% 0%, 86.9% 0%, 100% 100%, 0% 100%);\r\n}\r\n\r\n#startButton {\r\n  /* Content */\r\n  opacity: 0;\r\n\r\n  /* Size & Position*/\r\n  position: absolute;\r\n\r\n  z-index: 1;\r\n\r\n  left: 50%;\r\n  bottom: -100%;\r\n\r\n  transform: translate(-50%);\r\n\r\n  height: 100%;\r\n  width: 100%;\r\n\r\n  border-width: 0;\r\n\r\n  background-size: cover;\r\n\r\n  transition: opacity 0.2s ease-in-out;\r\n\r\n  animation-name: start-rise;\r\n  animation-duration: 0.4s;\r\n  animation-delay: 1.5s;\r\n  animation-timing-function: ease-in-out;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n#startButton:focus~#startButtonImage {  \r\n  opacity: 0;\r\n  transition: opacity 0.2s ease-in-out; \r\n} \r\n\r\n#startButton:hover~#startButtonImage {\r\n  opacity: 0;\r\n}\r\n\r\n#startButton:focus~#startButtonHighlight {\r\n  opacity: 1;\r\n}\r\n\r\n#startButton:hover~#startButtonHighlight {\r\n  opacity: 1;\r\n}\r\n\r\n\r\n#startButtonImage {\r\n    /* Content */\r\n    content: url(\"../../public/Images/Start/StartButtonImg.png\");\r\n    opacity: 1;\r\n    transition: opacity 0.2s ease-in-out;\r\n  \r\n    /* Size & Position*/\r\n    position: absolute;\r\n    left: 50%;\r\n    bottom: -100%;\r\n    transform: translate(-50%);\r\n  \r\n    height: 100%;\r\n    width: 100%;\r\n\r\n    pointer-events: none;\r\n  \r\n    animation-name: start-rise;\r\n    animation-timing-function: ease-in-out;\r\n    animation-duration: 0.4s;\r\n    animation-delay: 1.5s;\r\n    animation-fill-mode: forwards;\r\n} \r\n\r\n#startButtonHighlight {\r\n  /* Content */\r\n  content: url(\"../../public/Images/Start/StartButtonImg-Hover.png\");\r\n  opacity: 0;\r\n  transition: opacity 0.2s ease-in-out;\r\n\r\n  /* Size & Position*/\r\n  position: absolute;\r\n  left: 50%;\r\n  bottom: -100%;\r\n  transform: translate(-50%);\r\n\r\n  height: 100%;\r\n  width: 100%;\r\n\r\n  pointer-events: none;\r\n\r\n  animation-name: start-rise;\r\n  animation-timing-function: ease-in-out;\r\n  animation-duration: 0.4s;\r\n  animation-delay: 1.5s;\r\n  animation-fill-mode: forwards;\r\n} \r\n\r\n/* This is here to ensure the video never bleeds through the button image x.x */\r\n#startButtonBackground {\r\n  content: url(\"../../public/Images/Start/StartButtonImg.png\");\r\n  opacity: 1;\r\n\r\n  /* Size & Position*/\r\n  position: absolute;\r\n  left: 50%;\r\n  bottom: -100%;\r\n  transform: translate(-50%);\r\n\r\n  height: 100%;\r\n  width: 100%;\r\n\r\n  pointer-events: none;\r\n\r\n  animation-name: start-rise;\r\n  animation-timing-function: ease-in-out;\r\n  animation-duration: 0.4s;\r\n  animation-delay: 1.5s;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n#EnvSelect {\r\n  position: absolute;\r\n  width: 430px;\r\n  height: 1em;\r\n\r\n  top: 10px;\r\n  left: 10px;\r\n\r\n  font-size: 2em;\r\n\r\n  z-index: inherit;\r\n\r\n  color: Black;\r\n\r\n  background-color: Green;\r\n}\r\n\r\n@keyframes start-rise {\r\n  0% {\r\n    bottom: -100%;\r\n    pointer-events: none;\r\n  }\r\n\r\n  99% {\r\n    pointer-events: none;\r\n  }\r\n\r\n  100% {\r\n    bottom: 0px;\r\n    pointer-events: all;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
